import React, { useEffect, useState } from 'react';
import {
    Box,
    FormControl,
    FormLabel,
    TextField,
    Button
} from '@mui/material';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';

const Signup = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        confirmPassword: '',
        firstName: '',
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        localStorage.clear();
    }, []);

    const validate = () => {
        const newErrors = {};
        const { email, password, confirmPassword, firstName } = formData;

        if (!firstName.trim()) newErrors.firstName = 'Name is required';

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = 'Enter a valid email';
        }

        if (!password || password.length !== 8 || isNaN(password)) {
            newErrors.password = 'Password must be 8 digits';
        }

        if (password !== confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: '' })); // Clear error as user types
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setLoading(true);
        const payload = {
            name: formData.firstName,
            email: formData.email,
            password: formData.password,
            password_confirmation: formData.confirmPassword
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_LARAVEL_API_URL}/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (data?.token) {
                localStorage.setItem('token', data.token);
                toast.success("Successfully Registered");
                window.location.href = "https://alfboss.alfmedicaid.com/dashboard";
            } else {
                toast.error(data?.message || 'Error in creating account');
            }
        } catch (err) {
            toast.error('Something went wrong.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (formData.confirmPassword && formData.password !== formData.confirmPassword) {
            setErrors(prev => ({ ...prev, confirmPassword: 'Passwords do not match' }));
        } else {
            setErrors(prev => ({ ...prev, confirmPassword: '' }));
        }
    }, [formData.password, formData.confirmPassword]);


    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
            {loading && <Loader />}
            <div className="flex items-center justify-center min-h-screen p-4">
                <div className="bg-white rounded-xl p-8 max-w-md w-full">
                    <div className="text-center mb-4">
                        <img
                            src='/Images/logomb.png'
                            alt="Medicaid Logo"
                            className="mx-auto mb-1"
                            width="80px"
                        />
                        <h1 className="text-2xl font-bold text-gray-800">Create Your Medicaid Account</h1>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-2">
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <FormControl fullWidth>
                                <FormLabel>Name</FormLabel>
                                <TextField
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    placeholder="Enter your name"
                                    error={!!errors.firstName}
                                    helperText={errors.firstName}
                                    size="small"
                                />
                            </FormControl>

                            <FormControl fullWidth>
                                <FormLabel>Email</FormLabel>
                                <TextField
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Enter your email"
                                    error={!!errors.email}
                                    helperText={errors.email}
                                    size="small"
                                />
                            </FormControl>

                            <FormControl fullWidth>
                                <FormLabel>Password</FormLabel>
                                <TextField
                                    name="password"
                                    type="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    placeholder="8 digit password"
                                    error={!!errors.password}
                                    helperText={errors.password}
                                    size="small"
                                />
                            </FormControl>

                            <FormControl fullWidth>
                                <FormLabel>Confirm Password</FormLabel>
                                <TextField
                                    name="confirmPassword"
                                    type="password"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    placeholder="Re-enter password"
                                    error={!!errors.confirmPassword}
                                    helperText={errors.confirmPassword || " "}
                                    size="small"
                                />
                            </FormControl>
                        </Box>

                        <div className="pt-2 mt-1">
                            <Button variant="contained" type="submit" fullWidth>
                                Continue
                            </Button>
                        </div>

                        <div className="text-center">
                            <p className="text-gray-600 mt-2 mb-2">
                                Already have an account?{' '}
                                <a href="/signin" className="text-blue-600 font-medium">
                                    Sign in
                                </a>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Signup;
